'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
import blogFixedRight from '@/app/assets/imgs/blog/blog-fixed-right.png';
import { cn } from '@/app/utils';
import { CreateButton } from './CreateButton';

export const FloatingCard = () => {
  const t = useTranslations('blog.slug.createButton');
  const cardRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [topValue, setTopValue] = useState('33.333vh');

  useEffect(() => {
    const check = () => {
      const hero = document.querySelector('[data-blog-hero]');
      const breadcrumbs = document.querySelector('[data-blog-breadcrumbs]');
      const content = document.querySelector('[data-blog-content]');
      const cardEl = cardRef.current;
      const offset = breadcrumbs ? breadcrumbs.getBoundingClientRect().bottom : 0;
      setVisible(hero ? hero.getBoundingClientRect().bottom <= offset : false);

      if (content && cardEl) {
        const contentBottom = content.getBoundingClientRect().bottom;
        const fixedTop = window.innerHeight / 3;
        const cardHeight = cardEl.offsetHeight;
        const cardFixedBottom = fixedTop + cardHeight;

        if (contentBottom < cardFixedBottom) {
          setTopValue(`${contentBottom - cardHeight}px`);
        } else {
          setTopValue(`${fixedTop}px`);
        }
      }
    };
    check();
    window.addEventListener('scroll', check, { passive: true });
    return () => window.removeEventListener('scroll', check);
  }, []);

  return (
    <div className="relative">
      <div
        ref={cardRef}
        className={cn(
          'fixed left-[50%] z-10 translate-x-[400px] transition-opacity duration-300 lg:hidden',
          visible ? 'opacity-100' : 'pointer-events-none opacity-0',
        )}
        style={{ top: topValue }}
      >
        <div className="flex blog-md:hidden w-[14rem] flex-col items-start justify-end gap-4 rounded-[1.125rem] border border-[#000000]/[.20] bg-[#fff] p-5">
          <div className="flex h-[11.25rem] items-start gap-3">
            <div className="image flex h-[11.25rem] items-center justify-center rounded-2xl bg-[#15172f] pt-[2rem] pr-[1.4rem] pb-[1.9rem] pl-[1.4rem]">
              <Image src={blogFixedRight} alt="blogFixedRight" className="h-auto w-[8.375rem]" />
            </div>
          </div>
          <div className="flex w-[11.25rem] flex-col items-center justify-center gap-2">
            <div className="w-[11.25rem] text-center font-semibold text-black text-xl leading-[140%]">Vidu</div>
            <div className="w-[11.25rem] text-center text-black text-sm leading-[140%]">{t('description')}</div>
          </div>
          <CreateButton />
        </div>

        <div className="card blog-md:block hidden h-[17.875rem] w-[10.25rem] flex-shrink-0 rounded-[0.875rem] border-[#000000]/[.20] border-[1.468px] bg-white p-[0.9375rem]">
          <div className="name flex w-[8.25rem] flex-col items-center justify-center">
            <div className="images mb-[13px] flex h-[8.25rem] w-[8.25rem] flex-shrink-0 items-start gap-2">
              <div className="image flex h-[8.25rem] items-center justify-center rounded-xl bg-[#15172f] pt-[1.4rem] pr-[1rem] pb-[1.35rem] pl-[1rem]">
                <Image src={blogFixedRight} alt="blogFixedRight" className="h-auto w-[6.125rem]" />
              </div>
            </div>
            <div className="w-[8.25rem] text-center font-semibold text-black text-sm leading-[140%]">Vidu</div>
            <div className="w-[8.25rem] text-center text-[9px] text-black leading-[140%]">{t('description')}</div>
          </div>
          <CreateButton variant="md" />
        </div>
      </div>
    </div>
  );
};
